const icon = (paths: string) =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${paths}</svg>`;

export const MAP_EDITOR_ICONS: Record<string, string> = {
  point: icon('<path d="M20 10c0 6-8 11-8 11S4 16 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/>'),
  draw: icon(
    '<path d="m5 5 14 2-2 12-14-2Z"/><rect x="3" y="3" width="4" height="4" rx="1" fill="white"/><rect x="17" y="5" width="4" height="4" rx="1" fill="white"/><rect x="15" y="17" width="4" height="4" rx="1" fill="white"/><rect x="1" y="15" width="4" height="4" rx="1" fill="white"/>'
  ),
  coords: icon('<path d="m15 5 4 4M4 20l4-1L20 7a2.8 2.8 0 0 0-4-4L4 15l-1 6Z"/>'),
  info: icon('<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.01"/>'),
  delete: icon('<path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"/>'),
  clearAll: icon('<path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 11l4 6M14 11l-4 6"/>'),
  whisp: icon('<path d="M12 3 6 11h3l-4 6h14l-4-6h3Z"/><path d="M12 17v4"/>'),
};
